import React from 'react';
import RewardsListComponent from "../components/RewardsListComponent";
import {connect} from "react-redux";
import '../style/overview.css';
import TranslatedTextComponent from "../components/TranslatedTextComponent";
import NoRewardsFoundComponent from "../components/NoRewardsFoundComponent";

class RewardsOverviewPage extends React.Component {
    componentDidMount() {
        this.props.fetchRewards();
    }

    render() {
        if (this.props.rewardsAvailable == null) {
            return null;
        }

        if (this.props.rewards.length === 0)
            return <NoRewardsFoundComponent/>;

        return (
            <div className="reward-overview">
                <RewardsListComponent rewards={this.props.rewards}
                                      title={<TranslatedTextComponent textKey="rewards.dealTitle" />}
                                      onRewardClick={(friendlyName) => this.props.raiseRewardCardClickedEvent(friendlyName)}/>
            </div>
        );
    }

}


export default connect(
    (state) => {
        return {
            rewards: state.rewards.items,
            rewardsAvailable: state.rewards.rewardsAvailable
        }
    },
    (dispatch) => {
        return {
            fetchRewards: () => {
                dispatch({
                    type: 'FETCH_REWARDS'
                })
            },
            raiseRewardCardClickedEvent: (friendlyName) => {
                dispatch({
                    type: 'REWARD_CARD_CLICKED',
                    friendlyName
                })
            }
        }
    }
)(RewardsOverviewPage)

